// Orden y etiquetado de lanes, compartido por el calendario y por los pickers
// (bloqueos de lane, cierres por categoría).
//
// Los lanes se numeran POR CATEGORÍA: existe un "Lane 1" de Pistola y otro
// "Lane 1" de Rifle. Son lanes físicos distintos con el mismo nombre, así que
// en cualquier lista hay que mostrar la categoría o el empleado no sabe cuál
// está escogiendo.

const NO_CATEGORY = '￿'; // ordena al final

// Nombre de la primera categoría a la que pertenece el lane
export const laneCategoryName = (lane, categories) => {
  const cat = (categories || []).find(
    (c) => Array.isArray(lane.categoryIds) && lane.categoryIds.includes(c.id)
  );
  return cat ? cat.name : null;
};

const laneNumber = (lane) => {
  const m = String(lane.name || '').match(/\d+/);
  return m ? parseInt(m[0], 10) : 999;
};

// Agrupados por categoría (Pistola 1..n, luego Rifle 1..n, etc.)
export const sortLanes = (lanes, categories) =>
  [...(lanes || [])].sort((a, b) => {
    const ca = laneCategoryName(a, categories) || NO_CATEGORY;
    const cb = laneCategoryName(b, categories) || NO_CATEGORY;
    return (
      ca.localeCompare(cb, 'es') ||
      laneNumber(a) - laneNumber(b) ||
      String(a.name || '').localeCompare(String(b.name || ''), 'es')
    );
  });

// "Lane 1 · Pistola" — evita confundir lanes homónimos de distintas categorías
export const laneLabel = (lane, categories) => {
  const cat = laneCategoryName(lane, categories);
  return cat ? `${lane.name} · ${cat}` : lane.name;
};
